((CollectionsDisplay, $) => {
  'use strict';

  const hiddenClass = "collections-display-row-hidden";

  let $container;
  let $load;
  let $row;
  let index = 2;

  const cacheDom = () => {
    $container = $('.js-collections-display');
    $load = $container.find('.js-collections-display-load');
    $row = $container.find('.js-collecitons-display-row');
  };

  const iterate = () => {
    index += 1;
    return index;
  };

  const showMore = ($this) => {
    let hasNextIndex = false;
    let found = false
    $row.each(function () {
      const $this = $(this);
      if(!found && $this.attr('data-index') === index.toString()) {
        $this.removeClass(hiddenClass);
        found = true;
      }
    });

    iterate();

    if (parseInt($row.last().attr('data-index')) < index) {
      hasNextIndex = true;
    }

    if (hasNextIndex === true) {
      $this.parent().hide();
    }
  };

  const bindUIActions = () => {
    $load.on('click', function runLoad() {
      const $this = $(this);

      showMore($this);
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  CollectionsDisplay.init = init;
})(window.CollectionsDisplay = window.CollectionsDisplay || {}, jQuery);
